/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Bfsg_Statement_LinkInputs */

const en_about_bfsg_statement_link = /** @type {(inputs: About_Bfsg_Statement_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the accessibility statement`)
};

const de_about_bfsg_statement_link = /** @type {(inputs: About_Bfsg_Statement_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erklärung zur Barrierefreiheit lesen`)
};

const fr_about_bfsg_statement_link = /** @type {(inputs: About_Bfsg_Statement_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lire la déclaration d’accessibilité`)
};

const es_about_bfsg_statement_link = /** @type {(inputs: About_Bfsg_Statement_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer la declaración de accesibilidad`)
};

const it_about_bfsg_statement_link = /** @type {(inputs: About_Bfsg_Statement_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggi la dichiarazione di accessibilità`)
};

const nl_about_bfsg_statement_link = /** @type {(inputs: About_Bfsg_Statement_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lees de toegankelijkheidsverklaring`)
};

const pl_about_bfsg_statement_link = /** @type {(inputs: About_Bfsg_Statement_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeczytaj deklarację dostępności`)
};

const fi_about_bfsg_statement_link = /** @type {(inputs: About_Bfsg_Statement_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lue saavutettavuusseloste`)
};

const da_about_bfsg_statement_link = /** @type {(inputs: About_Bfsg_Statement_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Læs tilgængelighedserklæringen`)
};

const sv_about_bfsg_statement_link = /** @type {(inputs: About_Bfsg_Statement_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läs tillgänglighetsredogörelsen`)
};

/**
* | output |
* | --- |
* | "Read the accessibility statement" |
*
* @param {About_Bfsg_Statement_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_bfsg_statement_link = /** @type {((inputs?: About_Bfsg_Statement_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Bfsg_Statement_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_bfsg_statement_link(inputs)
	if (locale === "fr") return fr_about_bfsg_statement_link(inputs)
	if (locale === "es") return es_about_bfsg_statement_link(inputs)
	if (locale === "it") return it_about_bfsg_statement_link(inputs)
	if (locale === "nl") return nl_about_bfsg_statement_link(inputs)
	if (locale === "pl") return pl_about_bfsg_statement_link(inputs)
	if (locale === "fi") return fi_about_bfsg_statement_link(inputs)
	if (locale === "da") return da_about_bfsg_statement_link(inputs)
	if (locale === "sv") return sv_about_bfsg_statement_link(inputs)
	return en_about_bfsg_statement_link(inputs)
});